module.exports = __webpack_public_path__ + "static/the-organized-mind-2847e168346b9cd2dd8b5f228d380a32.jpg";